import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/pro-light-svg-icons';

const FavoriteIcon = ({ className = '', active, ...rest }) => {
  return <FontAwesomeIcon icon={faBookmark} {...rest} className={className} />;
};

export default FavoriteIcon;
